import { render, staticRenderFns } from "./LastsPublicLists.vue?vue&type=template&id=150e798c&scoped=true&"
import script from "./LastsPublicLists.ts?vue&type=script&lang=ts&"
export * from "./LastsPublicLists.ts?vue&type=script&lang=ts&"
import style0 from "./LastsPublicLists.vue?vue&type=style&index=0&id=150e798c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e798c",
  null
  
)

export default component.exports